import { CheckCircle2, Clock, AlertTriangle, MinusCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";

const MAP = {
  Completed: { icon: CheckCircle2, cls: "bg-[#D1E7DD] text-[#0F5132] border-[#BADBCE]", key: "completed" },
  "In progress": { icon: Clock, cls: "bg-[#CFF4FC] text-[#055160] border-[#B6EFFB]", key: "inProgress" },
  "Payment due": { icon: AlertTriangle, cls: "bg-[#FFF3CD] text-[#664D03] border-[#FFECB5]", key: "actionRequired" },
  skipped: { icon: MinusCircle, cls: "bg-[#E2E3E5] text-[#41464B] border-[#D3D6D8]", key: "skipped" },
};

export const requestStatus = (r) => (r.status !== "Completed" && r.workflow_step === 4 && r.fee_qar > 0 ? "Payment due" : r.status);

export const StatusBadge = ({ status, testId }) => {
  const { t } = useApp();
  const m = MAP[status] || MAP["In progress"];
  const Icon = m.icon;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${m.cls}`}>
      <Icon size={12} aria-hidden="true" /> {t(m.key)}
    </span>
  );
};
